import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import ContactsIcon from '@mui/icons-material/Contacts';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

export type SiteContactsDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const SiteContactsDetails = ({ control }: SiteContactsDetailsProps) => {
  const { errors } = useFormState({ control });

  const { general: { siteContacts } = {} } = useWatch({ control });

  const count = siteContacts?.length ?? 0;
  const hasError = !!errors.general?.siteContacts;

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <ContactsIcon fontSize="inherit" />
            <span>&nbsp;Site contacts</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Count:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              hasError ? 'error' : count === 0 ? 'textDisabled' : 'textPrimary'
            }>
            {count === 0
              ? 'No contacts added'
              : `${count} contact${count !== 1 ? 's' : ''}`}
          </Typography>
        </Grid>
        {count > 0 && (
          <Grid container justifyContent="space-between">
            <Typography component="span" variant="body2">
              Names:
            </Typography>
            <Typography component="span" variant="body2" color="textPrimary">
              {siteContacts
                ?.map((c) => c.name)
                .filter(Boolean)
                .join(', ')}
            </Typography>
          </Grid>
        )}
        <Divider />
      </Stack>
    </Box>
  );
};
